import { useState, useEffect, Suspense } from 'react'
import { RouterProvider } from 'react-router-dom'
import { ConfigProvider } from 'antd'
import idID from 'antd/locale/id_ID'
import { router } from '@/presentation/routes'
import { antdTheme } from '@/config/theme.config'
import PageLoader from '@/presentation/components/common/PageLoader'
import ErrorBoundary from '@/presentation/components/common/ErrorBoundary'
import { ToastProvider } from '@/presentation/components/common/ToastContainer'

function App() {
  const [isInitializing, setIsInitializing] = useState(true)

  useEffect(() => {
    // Simulate initial app loading (e.g., fetching config, checking auth)
    const timer = setTimeout(() => {
      setIsInitializing(false)
    }, 1500) // Adjust time as needed

    return () => clearTimeout(timer)
  }, [])

  if (isInitializing) {
    return <PageLoader loading={true} />
  }

  return (
    <ErrorBoundary>
      <ToastProvider>
        <ConfigProvider theme={antdTheme} locale={idID}>
          <Suspense fallback={<PageLoader loading={true} />}>
            <RouterProvider router={router} />
          </Suspense>
        </ConfigProvider>
      </ToastProvider>
    </ErrorBoundary>
  )
}

export default App
